module.exports = __webpack_public_path__ + "fonts/0be5590f-8353-4ef3-ada1-43ac380859f8.9bb4603.ttf";